// # services
import { auth } from "@/services";

(function (angular) {
  "use strict";

  angular.module("app").controller("myPollsController", myPollsController);

  myPollsController.$inject = [
    "pollsPayload",
    "Polls",
    "PollsApi",
    "$rootScope",
  ];

  function myPollsController(pollsPayload, Polls, PollsApi, $rootScope) {
    var vm = this;

    // properties
    vm.isLoading = false;
    vm.polls = angular.copy(pollsPayload);
    vm.filters = {
      user_id: $rootScope.thisUser.id,
      only_active: 0,
      with: "pollOptions",
      page: 1,
    };

    // methods
    vm.createPoll = createPoll;
    vm.editPoll = editPoll;
    vm.getPolls = getPolls;
    vm.permissionChecks = {
      canCreate: auth.hasPermission("polls.create"),
    };

    /**
     * Retrieves the user's events from the API
     * @return {void}
     */
    function getPolls() {
      PollsApi.get(
        vm.filters,
        function handleGetPollsResponse(response) {
          vm.polls = response;
          vm.isLoading = false;
        },
        function handleGetPollsError() {
          vm.isLoading = false;
        },
      );
    }

    /**
     * Shows the create poll modal then refreshes polls
     * @return {void}
     */
    function createPoll() {
      Polls.managePoll().result.then(function () {
        getPolls();
      });
    }

    /**
     * Shows the edit poll modal then refreshes polls
     * @param  {int} pollId - ID of poll to edit
     * @return {void}
     */
    function editPoll(pollId) {
      Polls.managePoll(pollId).result.then(function () {
        getPolls();
      });
    }

    // init
    vm.polls.data = [];
    angular.forEach(pollsPayload.data, function (poll) {
      vm.polls.data.push(new PollsApi(poll));
    });
  }
})(angular);
